import { render, staticRenderFns } from "./CustomerDetails.vue?vue&type=template&id=4a7eebf6"
import script from "./CustomerDetails.vue?vue&type=script&lang=js"
export * from "./CustomerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports